<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px">
				<el-form-item label="模板名称:">
					<el-col :span="3">
						<el-input v-model="listQuery.search.name" placeholder="请输入模板名称"></el-input>
					</el-col>
					<el-col :span="4" style="margin-left: 10px;">
						<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
					</el-col>
				</el-form-item>
			</el-form>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="create_time" label="创建时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="模板名称"> </el-table-column>
				<el-table-column prop="platform_init" label="平台"> </el-table-column>
				<el-table-column label="操作" fixed="right" width="180">
					<template slot-scope="{row,$index}">
						<el-button @click="daoru(row.id)" style="margin-left:10px;" type="primary" size="mini">导入发布</el-button>
						
						<el-popconfirm @confirm="handleDelete(row.id,$index)" @onConfirm="handleDelete(row.id,$index)"
							title="确定删除该数据？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		taskTmpl,tmplDel
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	export default {
		components: {
			Pagination,
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						name: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				taskTmpl(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			daoru(id){ // 导入发布
				this.$router.push({
					path: '/jd_task/add',
					query: { tid: id }
				});
			},
			handleDelete(val,index){
				let post = {'id':val}
				tmplDel(Qs.stringify(post)).then(response => {
					this.data_list.splice(index, 1)
					this.$message({
						showClose: true,
						message: '删除成功',
						type: 'success'
					});
				})
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
